import * as React from "react";

const Filter: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 11.25" fill="currentColor">
            <path
                fill="#00205B"
                d="M11.25 8.625H5.84a1.872 1.872 0 0 0-3.43 0H.75a.75.75 0 0 0 0 1.5h1.658a1.874 1.874 0 0 0 3.434 0h5.408a.75.75 0 0 0 0-1.5Zm-7.125 1.5a.751.751 0 0 1 0-1.5.751.751 0 0 1 0 1.5Zm7.125-5.25H9.592a1.872 1.872 0 0 0-3.432 0H.75a.75.75 0 1 0 0 1.5h5.41a1.872 1.872 0 0 0 3.432 0h1.658a.75.75 0 0 0 0-1.5Zm-3.375 1.5a.751.751 0 0 1 0-1.5.751.751 0 0 1 0 1.5ZM.75 2.625h2.41a1.872 1.872 0 0 0 3.432 0h4.658a.75.75 0 0 0 0-1.5H6.59a1.87 1.87 0 0 0-3.43 0H.75a.75.75 0 0 0 0 1.5Zm4.125-1.5a.751.751 0 0 1 0 1.5.751.751 0 0 1 0-1.5Z"
            />
        </svg>
    );
};

export default React.memo(Filter);
